import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { jzkApi } from '../services/api';
import { JZKValidityProcessedItem } from '../types';
import { useTranslation } from '../utils/i18n';

import DownloadIcon from './DownloadIcon';

interface JZKHistoricalDataProps {
  onBack: () => void;
}

const JZKHistoricalData: React.FC<JZKHistoricalDataProps> = ({ onBack }) => {
  const { t } = useTranslation();
  const {
    data: historicalData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['jzk-validity'],
    queryFn: jzkApi.getValidity,
  });

  const handleDownload = (item: JZKValidityProcessedItem) => {
    // TODO: Implement actual download logic when fileUrl is available
    // eslint-disable-next-line no-console
    console.log(`Download JŽK ${item.number}/${item.year}`);
  };

  if (isLoading) {
    return (
      <div className="jzk-historical-data">
        <div className="jzk-loading">{t('loading.historicalData')}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="jzk-historical-data">
        <div className="jzk-error">{t('error.loadingHistoricalData')}</div>
      </div>
    );
  }

  return (
    <div className="jzk-historical-data">
      <div className="jzk-historical-top">
        <button className="btn-back" onClick={onBack}>
          {t('button.back')}
        </button>
        <div className="jzk-historical-title-section">
          <h2 className="historical-title">{t('title.historical')}</h2>
        </div>
      </div>

      <div className="jzk-historical-content">
        {historicalData &&
          Object.entries(historicalData)
            .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
            .map(([year, items]) => (
              <div key={year} className="jzk-year-card">
                <h3 className="year-title">{year}</h3>
                <div className="jzk-year-table">
                  <div className="jzk-year-table-header">
                    <div className="table-header-cell">{t('table.number')}</div>
                    <div className="table-header-cell">{t('table.validFrom')}</div>
                    <div className="table-header-cell">{t('table.file')}</div>
                  </div>
                  <div className="jzk-year-table-body">
                    {items.map((item) => (
                      <div key={`${year}-${item.number}`} className="jzk-year-table-row">
                        <div className="table-body-cell">{item.number}</div>
                        <div className="table-body-cell">
                          {new Date(item.validFrom).toLocaleDateString('cs-CZ', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
                        </div>
                        <div className="table-body-cell table-cell-center">
                          <button
                            className="btn-download"
                            onClick={() => handleDownload(item)}
                            title={t('button.download')}
                          >
                            <DownloadIcon className="download-icon" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default JZKHistoricalData;
